export const eventTypes = {
  formEvent: 'form',
  pageViewEvent: 'page_view',
  click: 'click',
  botEvent: 'bot',
  purchaseEvent: 'purchase',
  customEvent: 'custom',
}

export const event = {
  formEvent: {
    submit: 'submit',
    invalid: 'invalid',
  },
  pageViewEvent: {
    page_view: 'page_view',
  },
  clickEvent: {
    click: 'click',
  },
  botEvent: {
    submit: 'submit',
    invalid: 'invalid',
  },
  purchaseEvent: {
    purchase: 'purchase',
  },
  customEvent: {},
}
